import React, { Component } from 'react';
import './input-item.scss';
import PropTypes from 'prop-types';
import { noop } from '../../js/utils';

const propTypes = {
  prefix: PropTypes.string,
  required: PropTypes.bool,
  onFocus: PropTypes.func
};

const defaultProps = {
  prefix: 'lf-input',
  required: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  label: '',
  onFocus: noop
};

export default class InputItem extends Component {
  inputRef = null;

  constructor(props) {
    super(props);
    this.state = {};
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onFocus(e) {
    if (this.props.readOnly) {
      // Fix：ios端readOnly点击后仍然可以弹出键盘
      this.inputRef.blur();
    }

    this.props.onFocus(e);
  }

  onBlur(e) {
    setTimeout(() => {
      // fix ios12 wechat browser click failure after input
      if (document.body) {
        document.body.scrollTop = document.body.scrollTop;
      }
    }, 100);
    this.props.onFocus(e);
  }

  render() {
    const {
      prefix,
      label,
      extra,
      required,
      labelWidth,
      readOnly,
      children,
      onFocus,
      onBlur,
      disabled,
      className,
      ...restProps
    } = this.props;

    return (
      <div className={[`${prefix} ${disabled ? `${prefix}-disabled` : ''}`, className].join(' ')}>
        <div className={`${prefix}-div ${prefix}-label`} style={{ width: labelWidth }}>
          {required && <span className={`${prefix}-label__required`}>*</span>}
          {label}
        </div>
        <div className={`${prefix}-div ${prefix}-container`}>
          {
            children || (
              <input
                // eslint-disable-next-line no-return-assign
                ref={el => (this.inputRef = el)}
                readOnly={readOnly}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                disabled={disabled}
                {...restProps}
              />
            )
          }
        </div>
        {
          extra && <div className={`${prefix}-div ${prefix}-extra`}>{extra}</div>
        }
      </div>
    );
  }
}

InputItem.defaultProps = defaultProps;
InputItem.propTypes = propTypes;
